import { render, staticRenderFns } from "./subjectScoreAnalysis.vue?vue&type=template&id=5c6b2a44&scoped=true"
import script from "./subjectScoreAnalysis.vue?vue&type=script&lang=js"
export * from "./subjectScoreAnalysis.vue?vue&type=script&lang=js"
import style0 from "./subjectScoreAnalysis.vue?vue&type=style&index=0&id=5c6b2a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b2a44",
  null
  
)

export default component.exports